<template>
  <NuxtLayout :name="pageLayout">
    <main v-if="page" class="page-default">
      <HeaderModule v-if="page.headerModule" :module="page.headerModule" />
      <Modules :modules="page.modules" />
    </main>
  </NuxtLayout>
</template>

<script setup lang="ts">
import { useSeo } from '~/utils/useSeo';
import Modules from '~/components/modules/Modules.vue';
import HeaderModule from '~/components/header-modules/HeaderModule.vue';

const route = useRoute();
const slug = String(route.params.slug);

const i18n = useI18n();

const { data, error } = await useAsyncGql({
  operation: 'GetPageBySlug',
  variables: { slug, locale: i18n.localeProperties.value.siteLocale },
});

const page = data.value?.page;

if (!page || error.value) {
  showError({
    statusCode: 404,
  });
}

if (page) {
  useSeo(page._seoMetaTags ?? []);
}

const pageLayout = computed(function () {
  if (!page) {
    return 'layout-default';
  }

  if (
    page.pageLayout === 'layout-default' ||
    page.pageLayout === 'layout-minimal'
  ) {
    return page.pageLayout;
  }

  return 'layout-default';
});
</script>

<style scoped lang="scss">
.page-default {
  > .header,
  > .module {
    padding: var(--base-component-padding);
    position: relative;

    &::after {
      content: attr(data-module);
      position: absolute;
      inset: 2rem auto auto var(--base-component-padding-inline);
      font-size: 0.8rem;
      background-color: lightgreen;
    }
  }

  > .mark {
    margin: var(--base-component-padding);
    display: block;
    font-size: 1rem;
    background-color: #ffad8f;
    width: fit-content;
  }
}
</style>
